export default "__VITE_ASSET__d9x2w$KH__"